import { Flex } from "@chakra-ui/react";
import { Fragment } from "react";
import { KELP_INFO } from "../landingConstants";
import { Section } from "../utils";
import InfoCard from "./InfoCard";

const Info = () => {
  return (
    <Section>
      <Flex
        gap={{ base: "16px", md: "24px" }}
        alignItems="center"
        justifyContent="center"
        flexDir={{ base: "column", md: "row" }}
      >
        {KELP_INFO.map((data) => (
          <Fragment key={data.title}>
            <InfoCard data={data} />
          </Fragment>
        ))}
      </Flex>
    </Section>
  );
};

export default Info;
